// extracted by mini-css-extract-plugin
export default {"checkbox":"djkpWV","checkboxError":"susScW"};